export default (self)=> {
  let columnDefs = []
  columnDefs = [
    {
      headerName: '',
      width: 30,
      field: 'rowIndex',
      hidden: true,
      suppressMovable: true,
      cellStyle: {
        textAlign: 'center',
        padding: '5px 0',
        color: '#595959',
        backgroundColor: '#f0f0f0',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '500',
        boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
      }
    },
    {
      headerName: '姓名',
      field: 'fullName',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '账号',
      field: 'userName',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '手机号',
      field: 'mobile',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '身份证号/工号',
      field: 'idCard',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '成绩',
      field: 'score',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '通过状态',
      field: 'passName',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '用户属性',
      field: 'userTypeName',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '账号状态',
      field: 'accountStatus',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '阅卷时间',
      field: 'markingDate',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '区域',
      field: 'areaName',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '组织名称',
      field: 'orgName',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '组织编码',
      field: 'orgCode',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '岗位',
      field: 'positionName',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '任职状态',
      field: 'jobStateName',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '考试时间',
      field: 'startDate',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },
    {
      headerName: '交卷时间',
      field: 'endDate',
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      },
    },

  ]
  return columnDefs;
}
